import React from 'react';
import { Link } from 'react-router-dom'; // Needed for navigation
import pagenotfound from './asset/pagenotfound.webp';
import { useEffect } from 'react';
function PageNotFound() {

  useEffect(() => {
  if (!window.location.search.includes('404=true')) {
    window.history.replaceState({}, '', window.location.pathname + '?404=true');
  }
}, []);

// useEffect(() => {
//     const url = new URL(window.location.href);
//     if (url.searchParams.get('404') !== 'true') {
//       url.searchParams.set('404', 'true');
//       window.location.replace(url.toString()); // ⬅ full page reload
//     }
//   }, []);

  return (
    <div style={{ textAlign: 'center', padding: '50px', marginTop: '45px' }}>
      <img src={pagenotfound} alt="Page Not Found" style={{ maxWidth: '100%', height: '214px' }} />
      <h1>Oh no, something went wrong!</h1>
      <p>Either something went wrong or this page doesn't exist anymore.</p>
      
      <Link to="/">
        <button style={{
          padding: '10px 20px',
          fontSize: '16px',
          marginTop: '20px',
          cursor: 'pointer',
          border: 'none',
          backgroundColor: 'rgb(239 93 0)',
          color: 'white',
          borderRadius: '5px'
        }}>
          Take me to Homepage
        </button>
      </Link>
    </div>
  );
}

export default PageNotFound;
